export const getUploadedFiles = (state) => state.uploader.list
export const getIsFetching = (state) => state.uploader.params.isFetching
export const getIsFetched = (state) => state.uploader.params.isFetched
